import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  IconMoney,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { Nominal, RegularBenefitVariant } from '../../../../../../../typings'
import { ViewProps } from '../../View'
import { messages } from './messages'

type Props = ViewProps & {
  config: Nominal
}

export function NominalView(props: Props) {
  const { onEdit, onRemove, config } = props

  const { formatCurrency } = useNumbers()

  const handleEdit = () => onEdit(RegularBenefitVariant.Nominal)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconMoney />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>{formatCurrency(config.value)}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
